const ACC_AUTHORIZED = "accAuthorized";
const VENDOR_AUTHORIZED = "vendorAuthorized";

export const convertAgreementFormDataToReqData = (data: any) => {
  const accAuthorizedObj: any = {
    observerType: ACC_AUTHORIZED,
  };

  const vendorAuthorizedObj: any = {
    observerType: VENDOR_AUTHORIZED,
  };

  const formatedData: any = {
    employee: [],
  };

  if (
    !data &&
    data?.accWitness?.length === 0 &&
    data?.vendorWitness?.length === 0
  ) {
    return data;
  } else {
    Object.keys(data).forEach((key) => {
      const keyArr = key.split("-");

      if (key.includes(ACC_AUTHORIZED)) {
        accAuthorizedObj[keyArr[1]] = data[key];
      } else if (key.includes(VENDOR_AUTHORIZED)) {
        vendorAuthorizedObj[keyArr[1]] = data[key];
      } else if (
        Array.isArray(data[key]) &&
        data[key].length !== 0 &&
        key !== "documents"
      ) {
        const formatedKey = data[key].map((item: any) => {
          return {
            ...item,
            observerType: key,
          };
        });

        formatedData.employee = [...formatedData.employee, ...formatedKey];
      } else {
        formatedData[key] = data[key];
      }
    });

    formatedData.employee.push(accAuthorizedObj);
    formatedData.employee.push(vendorAuthorizedObj);
  }

  return formatedData;
};

export function convertAgreementResDataToFormData(data: any) {
  const convertedData: any = {
    accWitness: [],
    vendorWitness: [],
  };

  const reqData = { ...data };

  if (!data.employee) {
    delete data.employee;
    return data;
  } else {
    Object.keys(reqData).forEach((key) => {
      if (Array.isArray(reqData[key]) && key.includes("employee")) {
        reqData[key].forEach((item: any) => {
          if (
            item.observerType === "accAuthorized" ||
            item.observerType === "vendorAuthorized"
          ) {
            convertedData[`${item.observerType}-name`] = item.name;
            convertedData[`${item.observerType}-designation`] =
              item.designation;
            convertedData[`${item.observerType}-email`] = item.email;
            convertedData[`${item.observerType}-phoneNumber`] =
              item.phoneNumber;
            convertedData[`${item.observerType}-details`] = item.details;
            convertedData[`${item.observerType}-employeeId`] = item.employeeId;
          } else {
            if (convertedData[item.observerType]) {
              const type = item.observerType;
              delete item.id;
              delete item.observerType;
              convertedData[type].push(item);
            }
          }
        });
      } else {
        convertedData[key] = data[key];
      }
    });

    return convertedData;
  }
}
